/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const CalendarSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.25 2.5V4.375M13.75 2.5V4.375M3.125 16.875V7.5C3.125 6.80964 3.68464 6.25 4.375 6.25H15.625C16.3154 6.25 16.875 6.80964 16.875 7.5V16.875M3.125 16.875C3.125 17.5654 3.68464 18.125 4.375 18.125H15.625C16.3154 18.125 16.875 17.5654 16.875 16.875M3.125 16.875V10.625C3.125 9.93464 3.68464 9.375 4.375 9.375H15.625C16.3154 9.375 16.875 9.93464 16.875 10.625V16.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default CalendarSvg
